import {
  CloudinaryGif,
  CloudinaryVideo,
  WrappedImage,
} from '@time-line/components/common';
import type { AspectRatio } from '@time-line/components/types';
import { ratioToDecimal } from '@time-line/components/utils';
import type { ProductMedia } from 'types/cms/pages/ProductPage';

interface MediaItemProps {
  galleryItem: ProductMedia;
  index: number;
  title: string;
  visibleIndex: number | null;
  isInset?: boolean;
  aspectRatio?: AspectRatio;
}

export function ProductGalleryMobileMediaItem({
  galleryItem,
  index,
  title,
  visibleIndex,
  isInset = false,
  aspectRatio = '1:1',
}: MediaItemProps) {
  const ratio = ratioToDecimal(aspectRatio);

  switch (galleryItem._type) {
    case 'video':
      return (
        <CloudinaryVideo
          title={title}
          aspectRatio={aspectRatio}
          cloudinaryId={galleryItem.cloudinaryId}
          poster={galleryItem.poster}
          canPlay={visibleIndex === index && !isInset}
          controls={!isInset}
          hasAudio={galleryItem.hasAudio}
        />
      );
    case 'image':
      return (
        <WrappedImage
          alt={title}
          image={galleryItem}
          sizes={
            isInset
              ? '30vw'
              : '(min-width: 1920px) 948px, (min-width: 960px) 50vw, 87vw'
          }
          priority={index === 0 && !isInset}
          ratio={ratio}
        />
      );
    case 'gif':
      return (
        <CloudinaryGif
          title={title}
          cloudinaryId={galleryItem.cloudinaryId}
          width="100%"
          height="100%"
          objectFit="cover"
          aspectRatio={aspectRatio}
        />
      );
    default:
      return null;
  }
}
